import _ from 'lodash';

import {
  DASHBOARD_URL,
  ANALYTICS_URL,
  COMPANIES_URL,
  SOLUTIONS_URL,
  SERVICE_PROVIDERS_URL,
  CREATE_COMPANY_URL,
  ENTERPRISE_PRODUCTS_URL,
  CREATE_TENDER_URL,
  TENDERS_LIST_URL,
  TENDER_OVERVIEW_URL,
  INVESTORS_URL,
  RESOURCES_URL,
  NEWS_URL,
  CASE_STUDIES_URL,
  COMPANY_PREDEFINED_SEARCH_URL,
  UNISCORE_REPORT_URL,
  CHERRY_PICK_URL,
  TENDER_SUBSCRIBE_URL
} from 'global-constants';

import { substituteUrl } from 'shared/utils/substituteUrl';

import { TENDERS_TABS } from 'pages/Tender/List/constants';
import { CREATE_TENDERS_PAGE_TABS } from 'pages/Tender/Create/constants';

export const SECTION_TO_URL_MAPPING = {
  DIRECTORY: [
    COMPANIES_URL,
    SOLUTIONS_URL,
    SERVICE_PROVIDERS_URL,
    CREATE_COMPANY_URL,
    INVESTORS_URL,
    COMPANY_PREDEFINED_SEARCH_URL
  ],
  ENTERPRISE: [ENTERPRISE_PRODUCTS_URL],
  TENDERS: [
    TENDER_OVERVIEW_URL,
    ..._.map(_.keys(CREATE_TENDERS_PAGE_TABS), activeTab =>
      substituteUrl(CREATE_TENDER_URL, { activeTab })
    ),
    ..._.map(_.keys(TENDERS_TABS), activeTab =>
      substituteUrl(TENDERS_LIST_URL, { activeTab })
    )
  ],
  CONTENT_LIBRARY: [RESOURCES_URL, NEWS_URL, /* EVENTS_URL, */ CASE_STUDIES_URL]
};

export const NAV_ITEMS = {
  YOUR_HUB: [
    {
      id: 'navigation-feed',
      title: 'Feed',
      description:
        'Your personalised content feed. Featuring content from the solutions, influencers and Companies that you follow.',
      url: DASHBOARD_URL
    },
    {
      id: 'navigation-analytics',
      title: 'Analytics',
      description:
        'Use our data dashboard to find the insights and information you need. Investments, trends, sector analysis and more!',
      url: ANALYTICS_URL
    }
  ],
  DIRECTORY: [
    {
      id: 'navigation-companies',
      title: 'PropTech Companies',
      description:
        'Use our powerful search filters to find the PropTech companies that will help you solve your key business issues.',
      url: COMPANIES_URL
    },
    {
      id: 'navigation-investors',
      title: 'PropTech Investors',
      url: INVESTORS_URL
    },
    {
      id: 'navigation-service-providers',
      title: 'Services',
      description:
        'Search, view and connect with PropTech Service Providers from across the world.',
      url: SERVICE_PROVIDERS_URL
    },
    {
      id: 'navigation-solutions',
      title: 'Browse Solutions',
      description:
        'Dive into our PropTech solutions to find the market leading companies, influencers and content to help you make decisions more efficiently.',
      url: SOLUTIONS_URL
    }
  ],
  TENDERS: {
    logged: [
      { title: 'For Buyers' },
      {
        id: 'navigation-project-overview',
        title: 'Overview',
        url: TENDER_OVERVIEW_URL
      },
      {
        id: 'navigation-create-project',
        title: 'Create a Project',
        url: substituteUrl(CREATE_TENDER_URL, { activeTab: 'create' })
      },
      {
        id: 'navigation-my-projects',
        title: 'My Projects',
        url: substituteUrl(CREATE_TENDER_URL, { activeTab: 'my-projects' })
      },
      { title: 'For Sellers' },
      {
        id: 'navigation-available-projects',
        title: 'Available Projects',
        url: substituteUrl(TENDERS_LIST_URL, { activeTab: 'open' })
      },
      {
        id: 'navigation-subscriptions',
        title: 'Subscriptions',
        externalUrl: TENDER_SUBSCRIBE_URL
      },
      {
        id: 'navigation-my-submissions',
        title: 'My Submissions',
        url: substituteUrl(TENDERS_LIST_URL, { activeTab: 'my-submissions' })
      }
    ],
    unlogged: [
      { title: 'For Buyers' },
      {
        id: 'navigation-project-overview',
        title: 'Overview',
        url: TENDER_OVERVIEW_URL
      },
      {
        id: 'navigation-create-project',
        title: 'Create a Project',
        url: substituteUrl(CREATE_TENDER_URL, { activeTab: 'create' })
      },
      { title: 'For Sellers' },
      {
        id: 'navigation-available-projects',
        title: 'Available Projects',
        url: substituteUrl(TENDERS_LIST_URL, { activeTab: 'open' })
      },
      {
        id: 'navigation-subscriptions',
        title: 'Subscriptions',
        externalUrl: TENDER_SUBSCRIBE_URL
      }
    ]
  },
  CONTENT_LIBRARY: [
    {
      id: 'navigation-connect-videos',
      title: 'UniScore Reports',
      externalUrl: UNISCORE_REPORT_URL
    },
    {
      id: 'navigation-cherry-pick',
      title: 'Innovators in Real Estate Report',
      externalUrl: CHERRY_PICK_URL
    },
    {
      id: 'navigation-articles',
      title: 'Articles',
      url: RESOURCES_URL
    },
    {
      id: 'navigation-news',
      title: 'News',
      url: NEWS_URL
    },
    {
      id: 'navigation-case-studies',
      title: 'Case Studies',
      url: CASE_STUDIES_URL
    }
  ]
};
